// Utility to determine if a field is required
// Handles both boolean and function types for `required`
import { FormFieldConfig } from '../types/mold';

/**
 * Returns whether a field is required, supporting both boolean and function types.
 * @param field The form field config
 * @param details The current form details (order detail or form state)
 */
export function isFieldRequired(field: FormFieldConfig, details: any): boolean {
  if (typeof field.required === 'function') {
    return field.required(details);
  }
  return field.required === true;
}

/**
 * Returns whether a field is disabled for the given user role.
 * A disabled field stays editable for roles listed in `enabledForRoles`.
 * @param field The form field config
 * @param userRole The current user's role, if any
 */
export function isFieldDisabledForUser(
  field: FormFieldConfig,
  userRole?: string,
): boolean {
  if (!field.disabled) return false;
  return !(userRole && field.enabledForRoles?.includes(userRole));
}
